/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpfundcontribution_Update_Error3Inputs */

const en_coinvestments_gpfundcontribution_update_error3 = /** @type {(inputs: Coinvestments_Gpfundcontribution_Update_Error3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update GP fund contribution`)
};

/**
* | output |
* | --- |
* | "Failed to update GP fund contribution" |
*
* @param {Coinvestments_Gpfundcontribution_Update_Error3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpfundcontribution_update_error3 = /** @type {((inputs?: Coinvestments_Gpfundcontribution_Update_Error3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpfundcontribution_Update_Error3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpfundcontribution_update_error3(inputs)
});
export { coinvestments_gpfundcontribution_update_error3 as "coInvestments_gpFundContribution_update_error" }